import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

import logo from "../../assets/images/dofy.png";
import logoSm from '../../assets/images/logo-sm.png'
import SidebarContents from "./SidebarContents";
import { isMobile } from "../../helpers/Helper";
import { Offcanvas } from "reactstrap";

const Sidebar = (props: any) => {

  return (
    <React.Fragment>
      {!isMobile() ?
        <div className="vertical-menu">
          <div className="navbar-brand-box">
            <Link to="/homepage" className="logo logo-light">
              <span className="logo-lg">
                <img src={logo} alt="" height="26" />
              </span>
              <span className="logo-sm">
                <img src={logoSm} alt="" height="50" style={{ position: 'relative', right: "15px" }} />
              </span>
            </Link>
          </div>
          <div data-simplebar className="h-100">
            {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent/>}
          </div>
          <div className="sidebar-background"></div>
        </div> :
        <Offcanvas isOpen={props.show} direction='start' backdrop={true} toggle={props.toggleCanvas} className='right-bar' style={{ background: '#17284b', border: "unset" }}>
          <SidebarContent toggleCanvas={props.toggleCanvas} />
        </Offcanvas>}
    </React.Fragment>
  );
};

export default Sidebar;